export default import.meta.ROLLUP_FILE_URL_UqgWuU74pwaSiWGhKsk0qw;